import styled from 'styled-components/macro'

export const StyledExternalLink = styled.a`
  text-decoration: none;
  font-weight: 500;
  width: content-fit;
`
